import * as React from 'react'

import { Download, MoreHorizontal, X } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import TooltipWrapper from '~/client/src/shared/components/TooltipWrapper/TooltipWrapper'

interface IProps {
  fileName: string
  onClose: () => void
  onDownload: () => void
  onPrint: () => void
}

const AttachmentModalHeader: React.FC<IProps> = ({
  fileName,
  onClose,
  onDownload,
}) => {
  return (
    <div className="attachment-modal-header row y-center pa5 bb-light-input-border">
      <div className="row x-start y-center full-width">
        <div className="no-grow attachment-modal-action-btn-group">
          <TooltipWrapper content="Close">
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X />
            </Button>
          </TooltipWrapper>
        </div>
        <div className="attachment-modal-file-name">
          <div
            className="text large bold text-ellipsis center"
            title={fileName}
          >
            {fileName}
          </div>
        </div>
        <div className="tw:flex tw:justify-evenly no-grow attachment-modal-action-btn-group">
          <TooltipWrapper className="no-grow" content="Download">
            <Button variant="ghost" size="icon" onClick={onDownload}>
              <Download />
            </Button>
          </TooltipWrapper>

          <Button variant="ghost" size="icon" disabled>
            <MoreHorizontal />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AttachmentModalHeader
